module.exports = solc;